const reg = new RegExp("^(?:[a-z+]+:)?//", "i");

export function isAbsoluteUrl(url: string): boolean {
  return reg.test(url);
}
